module.exports = __webpack_public_path__ + "img/13.b024ea98.svg";